export const details = {
  brokerNumber: "brokerNumber",
  transactionCount: "transactionCount",
  errorCount: "errorCount",
  address: "address",
  status: "status",
  fileName: "parentFileName"
}